<template>
  <v-app-bar color="transparent" dense flat elevation="0">
    <v-breadcrumbs
      divider="/"
      :items="breadcrumbs"
      class="ml-n6 breadcrumb-item"
    ></v-breadcrumbs>
    <v-spacer />
    <v-chip>
      <v-avatar
        color="primary"
        class="text-uppercase white--text mx-1 ml-n2 breadcrumb-item"
      >
        {{ employeeAbbreviation }}
      </v-avatar>
      {{ employee.number }}
    </v-chip>
  </v-app-bar>
</template>

<script>
export default {
  name: "DiscBreadcrumbs",
  computed: {
    breadcrumbs() {
      const matched = this.$route.matched.filter((el) => el.name);
      return matched.map((el) => {
        return {
          text: el.name,
          disabled: el.name === this.$route.name,
          href: el.path,
        };
      });
    },
    employee() {
      return this.$store.getters["auth/user"].profile;
    },
    employeeAbbreviation() {
      const name = [
        this.employee.first_name,
        this.employee.last_name || this.employee.middle_name,
      ]
        .join(" ")
        .trim();
      const parts = name.trim().split(/\s+/);

      if (parts.length < 2) return parts[0]?.charAt(0).toUpperCase() || "";

      return (parts[0][0] + parts[1][0]).toUpperCase();
    },
  },
};
</script>

<style scoped></style>
